import { render } from "./comments-role.vue?vue&type=template&id=5daa1ea3"
import script from "./comments-role.vue?vue&type=script&lang=js"
export * from "./comments-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__